import { api } from '../../../../lib/api';

/** Servicio mínimo de turnos (listado para otras pantallas de personas). */
export const shiftService = {
  async getAllShifts() {
    try {
      const data = await api.get('/api/labor/shifts');
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error getting shifts:', error);
      throw error;
    }
  },

  async getShiftsByFactory(factoryId) {
    try {
      const data = await api.get(`/api/labor/factory/${factoryId}/shifts`);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(`Error getting shifts from factory ${factoryId}:`, error);
      throw error;
    }
  },
};
